import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";

import { Grid, Button, Paper } from "@material-ui/core";

import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Header from "../../partials/header";
import { LANGUAGE_SUPPORT } from "../../utils/setting";
import Snackbar from "../snackbar";
import MenuGroup from "./menuGroup";
import EditMenuGroup from "./menuGroup/edit";
import MenuItem from "./menuItem";
import AddMenuItem from "./menuItem/add/index";
import { styles } from "./styles";

// style
class ListMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      allMenuItem: [],
      allMenuGroup: [],
      menuId: [],
      message: "",
      id: 1,
      array: [1],
      isEditMenu: false,
      menuSelected: [],
      typeEdit: "",
    };
    this.supportParseToString = this.supportParseToString.bind(this);
  }
  componentDidMount() {
    this.props.settingDispatch.getSettings();
  }
  supportParseToString(jsonSupport) {
    let result = "";
    LANGUAGE_SUPPORT.forEach((n) => {
      if (jsonSupport[n] === 1) {
        result += n.charAt(0).toUpperCase() + n.slice(1) + ",";
      }
    });
    return result.substr(0, result.length - 1);
  }
  handleMenuList = (payload = {}) => {
    this.MenuItem.getList(payload);
  };
  showModal = (tyleModal) => {
    if (tyleModal === "menuGroup") {
      this.ModalMenuGroup.show();
    } else if (tyleModal === "menuItem") {
      this.ModalMenuItem.show();
    }
  };
  finishAction = (status, type) => {
    let { t } = this.props;
    if (status === 1) {
      this.mSnackbar.handleClick(
        type === "edit"
          ? t("menu_menugroup_editmenugroup_edit_successfully")
          : type === "add"
            ? t("menu_add_successfully")
            : t("menu_menugroup_delete_successfully")
      );
      this.handleEditMenuGroup();
    } else {
      this.mSnackbar.handleClick(
        status
          ? status
          : type === "edit"
            ? `${t("menu_menugroup_editmenugroup_edit_unsuccessfully")}`
            : type === "add"
              ? `${t("menu_add_unsuccessfully")}`
              : `${t("menu_menugroup_delete_unsuccessfully")}`,
        "error"
      );
    }
    this.MenuGroup.getMenuGroup();
    this.MenuItem.getList();
  };
  handleEditMenuGroup = (item, type) => {
    if (item) {
      // trường hợp edit
      this.setState({
        menuSelected: item,
        isEditMenu: true,
        type: type,
      });
    } else {
      if (this.state.isEditMenu === true) {
        this.EditMenuGroup.resetValue();
      }
      this.setState({ isEditMenu: false });
    }
  };
  handleEditItem = () => {
    this.setState((pre) => ({ isEditItem: !pre.isEditItem }));
  };
  handleSearch = (event) => {
    const _this = this;
    this.setState(
      {
        search: event.target.value,
      },
      function () {
        _this.MenuItem.getList();
      }
    );
  };
  finishAction = (status, type) => {
    let { t } = this.props;
    if (status === 1) {
      this.mSnackbar.handleClick(
        type === "edit"
          ? t("menu_menugroup_editmenugroup_edit_successfully")
          : type === "add"
            ? t("menu_add_successfully")
            : t("menu_menugroup_delete_successfully")
      );
      this.handleEditMenuGroup();
    } else {
      this.mSnackbar.handleClick(
        type === "edit"
          ? `${t("menu_menugroup_editmenugroup_edit_unsuccessfully")} ${status}`
          : type === "add"
            ? `${t("menu_add_unsuccessfully")} ${status}`
            : `${t("menu_menugroup_delete_unsuccessfully")} ${status}`,
        "error"
      );
    }
    this.MenuGroup.getMenuGroup();
    this.MenuItem.getList();
  };
  handleSearch = (event) => {
    const _this = this;
    this.setState(
      {
        search: event.target.value,
      },
      function () {
        _this.MenuItem.getList();
      }
    );
  };
  setMenuId = (data = []) => {
    this.setState({ menuId: data });
  };
  actionBack = () => {
    this.props.history.push("/service/menu");
  };
  render() {
    const {
      classes,
      t,
      disabled = false,
      history,
      location
    } = this.props;
    const {
      isEditMenu = false,
      isEditItem = false,
      menuSelected = [],
      type,
      search = "",
      menuId = [],
    } = this.state;
    return (
      <div className={classes.root}>
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
          test="in"
        />
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            {" "}
            {isEditMenu ? (
              <Header
                session={t("menu_menu")}
                title={
                  !isEditMenu && !isEditItem
                    ? t("menu_menu")
                    : isEditItem
                      ? t("menu_menuitem_addmenuitem_add_new_menu_item")
                      : type === "edit"
                        ? t("menu_menuitem_edit_menu")
                        : t("menu_menugroup_addmenugroup_add_new_menu_group")
                }
                backIcon={true}
                actionBack={() => this.handleEditMenuGroup(null, "add")}
              // button= {t('customer_add_new_customer')}
              // actionButton= {this.handleEditMenuGroup(null, "add")}
              />
            ) : isEditItem ? (
              <Header
                session={t("menu_menu")}
                backIcon={true}
                actionBack={() => this.handleEditItem()}
                title={t("menu_menuitem_addmenuitem_add_new_menu_item")}
              // button= {t('customer_add_new_customer')}
              // actionButton= {this.handleEditItem}
              />
            ) : (
              <Header
                session={t("sidebar_service_and_product")}
                title={
                  !isEditMenu && !isEditItem
                    ? t("menu_menu")
                    : isEditItem
                      ? t("menu_menuitem_addmenuitem_add_new_menu_item")
                      : type === "edit"
                        ? t("menu_menuitem_edit_menu")
                        : t("menu_menugroup_addmenugroup_add_new_menu_group")
                }
              />
            )}{" "}
          </Grid>{" "}
          {!isEditMenu && !isEditItem ? (
            <>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <div className={classes.rootMenuItem}>
                  <div className={classes.frameTitle}>
                    {" "}
                    {
                      !disabled && !isEditMenu ? (
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.button}
                          onClick={() => this.handleEditMenuGroup({}, "add")}
                        >
                          {" "}
                          {t("add_menu")}{" "}
                        </Button>
                      ) : (
                        ""
                      )
                      // <Button color="primary" variant="outlined" className={classes.button} onClick={() => this.handleEditMenuGroup(null, "add")}>
                      //     {t('cancel')}
                      // </Button>
                    }{" "}
                  </div>{" "}
                  <Paper className={classes.paperMenuGroup}>
                    <MenuGroup
                      setMenuId={this.setMenuId}
                      getListItem={this.handleMenuList}
                      onRef={(id) => (this.MenuGroup = id)}
                      handleEditMenuGroup={this.handleEditMenuGroup}
                      disabled={disabled}
                    />{" "}
                  </Paper>{" "}
                </div>{" "}
              </Grid>{" "}
              <Grid item xs={12} sm={12} md={12} lg={8}>
                <MenuItem
                  label={t("menu_menuitem_menu_item")}
                  afterEdit={this.handleMenuList}
                  menuSelected={menuSelected}
                  menuId={menuId}
                  featured={false}
                  handleEditItem={this.handleEditItem}
                  onRef={(id) => (this.MenuItem = id)}
                  search={search}
                  disabled={disabled}
                  history={history}
                  location={location}
                />{" "}
                {/* <MenuItem label={t('menu_menuitem_featured_item')} afterEdit={this.handleMenuList} menuSelected={menuSelected} menuId={menuId} featured={true} onRef={id => (this.MenuItem = id)} disabled={disabled}/> */}{" "}
              </Grid>{" "}
            </>
          ) : isEditItem ? (
            <Grid item xs={12}>
              <Paper className={classes.paperMenuItem}>
                <AddMenuItem
                  onRef={(ModalMenuItem) =>
                    (this.ModalMenuItem = ModalMenuItem)
                  }
                  menuSelected={menuSelected}
                  menuId={menuId}
                  finishAction={this.finishAction}
                  handleCancel={this.handleEditItem}
                />{" "}
              </Paper>{" "}
            </Grid>
          ) : (
            <Grid item xs={12}>
              <Paper className={classes.paperMenuItem}>
                <EditMenuGroup
                  onRef={(id) => (this.EditMenuGroup = id)}
                  data={menuSelected}
                  finishAction={this.finishAction}
                  type={type}
                  handleCancel={() => this.handleEditMenuGroup()}
                />{" "}
              </Paper>{" "}
            </Grid>
          )}{" "}
        </Grid>{" "}
      </div>
    );
  }
}

ListMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  service: state.service.service,
});

const mapDispatch = (dispatch) => ({
  serviceMenuItemDispatch: dispatch.serviceMenuItem,
  settingDispatch: dispatch.setting,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(ListMenu)));
